import React, { lazy } from 'react';
import { LoadComponent, type RouteObject} from 'Routes/index';

const Atividades = lazy(() => import(`Pages/Screens/Office/Operational/Atividades`));

const OperationalRoutes: RouteObject[] = [
    {
      path: 'activities',
      element: <LoadComponent component={Atividades} />,
    },
]

export default OperationalRoutes;